/**
 * A viewport that draws nothing. Used when no GPU backend is available (the
 * editor still edits documents through panels and keyboard) and in tests.
 */
import { fitBounds, isValidCamera, screenToWorld, worldToScreen } from '../camera.js';
import { DEFAULT_GRID } from '../viewport.js';
export class NullViewport {
    size;
    camera = { center: [0, 0], scale: 1 };
    grid = { ...DEFAULT_GRID };
    overlay = {};
    hover = null;
    constructor(size = { width: 800, height: 600, dpr: 1 }) {
        this.size = size;
    }
    setCamera(c) {
        if (isValidCamera(c))
            this.camera = c;
    }
    screenToWorld(x, y) {
        return screenToWorld(this.camera, this.size, x, y);
    }
    worldToScreen(p) {
        return worldToScreen(this.camera, this.size, p);
    }
    setOverlay(o) {
        this.overlay = o;
    }
    setHover(id) {
        this.hover = id;
    }
    setGrid(g) {
        this.grid = { ...this.grid, ...g };
    }
    async fit(bounds, margin = 32) {
        if (bounds)
            this.camera = fitBounds(this.size, bounds, margin);
    }
    requestRender() { }
}
//# sourceMappingURL=null-viewport.js.map